import React, { useState } from "react";
import { Plus, X, MoreHorizontal } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

export function TrelloColumnHeader({ col, count, onAdd, onManage }) {
  return (
    <div className="flex items-center gap-2 px-3 pt-3 pb-2" data-testid={`trello-col-header-${col.id}`}>
      <span className="font-heading text-sm font-semibold uppercase tracking-wide text-norea-text truncate">{col.label}</span>
      <span className="ml-auto text-xs tabular-nums text-norea-textMuted">{count}</span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="p-1 rounded hover:bg-black/5" title="Afficher la liste des actions" data-testid={`trello-col-menu-${col.id}`}><MoreHorizontal className="w-4 h-4" /></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onAdd}>Ajouter une carte</DropdownMenuItem>
          {onManage && <DropdownMenuItem onClick={onManage}>Gérer les colonnes</DropdownMenuItem>}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

export function QuickAddCard({ col, basePath, open, setOpen, onCreated }) {
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!title.trim() || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post(basePath, { title: title.trim() });
      if (data.status !== col.id) await api.patch(`${basePath}/${data.id}/status`, { status: col.id });
      setTitle("");
      onCreated();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Création impossible");
    } finally {
      setBusy(false);
    }
  };
  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className="w-full flex items-center gap-1.5 px-3 py-2 rounded-md text-sm text-norea-textMuted hover:bg-black/5 hover:text-norea-text transition-colors" data-testid={`trello-add-card-${col.id}`}>
        <Plus className="w-4 h-4" /> Ajouter une carte
      </button>
    );
  }
  return (
    <div className="space-y-2 px-1" data-testid={`trello-quick-add-${col.id}`}>
      <textarea autoFocus value={title} onChange={(e) => setTitle(e.target.value)} rows={2}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } if (e.key === "Escape") setOpen(false); }}
        placeholder="Saisissez un titre pour cette carte…" className="w-full rounded-lg border border-norea-border bg-white p-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-norea-primary" data-testid={`trello-quick-add-input-${col.id}`} />
      <div className="flex items-center gap-2">
        <button onClick={submit} disabled={busy || !title.trim()} className="btn-primary text-xs" data-testid={`trello-quick-add-submit-${col.id}`}>Ajouter une carte</button>
        <button onClick={() => setOpen(false)} className="p-1 text-norea-textMuted hover:text-norea-text"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
